import React from 'react';

import '../styles/Loading.css';

function Loading({ message = "Loading content..." }) {
  return (
    <div className="loading-container">
      <span className="loading">{message}</span>
      <div className="loading-spinner"></div>
    </div>
  )
}

export default Loading;
